import { Box } from '@mui/material'
import { renderInline } from './renderInline'

const listSx = { my: 0.5, pl: 2.5, display: 'flex', flexDirection: 'column', gap: 0.5 }

/**
 * Legacy list branch. Fires only when *every* line in the block is a bullet or
 * every line is numbered — which is why a list containing a blank line falls
 * through to the paragraph branch (defect 4).
 *
 * @returns {JSX.Element | null} null when the block is not a uniform list
 */
export function renderTextBlockList(lines, citations, key) {
  const isBullet = lines.every((line) => /^[-*]\s+/.test(line))
  const isNumbered = lines.every((line) => /^\d+\.\s+/.test(line))
  if (!isBullet && !isNumbered) return null

  return (
    <Box component={isNumbered ? 'ol' : 'ul'} key={key} sx={listSx}>
      {lines.map((line, index) => (
        <Box component="li" key={index} sx={{ font: 'inherit' }}>
          {renderInline(line.replace(/^([-*]|\d+\.)\s+/, ''), citations, `${key}-li-${index}`)}
        </Box>
      ))}
    </Box>
  )
}
